/**
 * @fileoverview Agent definition for critique-dialogue.
 *
 * This agent analyzes dialogue for voice consistency, naturalness,
 * subtext, exposition handling, and character distinction.
 *
 * @category narrative.prose.critique
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'critique-dialogue',
  kind: 'primitive',
  name: 'Dialogue Critic',
  description: 'Analyzes dialogue for voice consistency, naturalness, subtext, exposition handling, and character distinction.',
  category: 'writing',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-01',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.prose.critique',
    usedBy: [
      'use-critique-dialogue.ts',
    ],
    usedInComposites: [
      'critique-committee-v2',
    ],
    relatedAgents: [
      'critique-prose-flow',
      'critique-sensory-atmosphere',
      'critique-voice-emotion',
    ],
  },
};
